// extracted by mini-css-extract-plugin
export default {"printDoc":"print_printDoc__jVuQm","s1":"print_s1__MsG+V","s4":"print_s4__1y9Sz","s4b":"print_s4b__1fhuE","s5":"print_s5__inlL4","s5b":"print_s5b__4LxSR","s6":"print_s6__pSlnm"};